// extracted by mini-css-extract-plugin
export var formContainer = "_f2-0";
export var message = "_f2-1";